
    import { Options, Vue } from 'vue-class-component';

    @Options<ApTab>({
        props: {
            name: {
                type: [String, Number],
                default: false,
            },
            modelValue: {
                type: [String, Number],
                default: null,
            },
            type: {
                type: String,
                default: 'ap-tab tab-primary',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
    })
    export default class ApTab extends Vue {
        public modelValue!: string | number;
        public name!: string | number;
        public disabled!: boolean;

        onChange(newVal: string | number) {
            this.$emit('update:modelValue', newVal);
            this.$emit('input', newVal);
            this.$emit('change', newVal);
        }

        async labelOnClick() {
            if (this.disabled || this.name == this.modelValue) {
                return;
            }
            const newVal = !this.modelValue;
            this.onChange(this.name);
        }
    }
